import {
  FETCH_PRICEFY_CONFIG_SUCCESS,
  FETCH_PRICEFY_CONFIG_ERROR,
} from 'constants/actionTypes'

const DEFAULT_STATE = {
  error: null,
  record: [],
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_PRICEFY_CONFIG_SUCCESS:
      return {
        ...state,
        error: null,
        record: action.payload,
      }
    case FETCH_PRICEFY_CONFIG_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return { ...state }
  }
}
